import { render, staticRenderFns } from "./AfaFitness.vue?vue&type=template&id=1cd5d546"
import script from "./AfaFitness.vue?vue&type=script&lang=js"
export * from "./AfaFitness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports